import React, { useMemo, useRef, useState, useEffect, useLayoutEffect } from "react";
import { useWindowSize } from "../../global/hooks/viewportHooks";
import { breakpoints } from "../../styles/breakpoints";
import PolygonAnnotation from "../../polygonLib/eaePolygon";
import {
  Stage,
  Layer,
  Image,
  Line,
  Text,
  Circle,
  Group,
  Rect,
  Transformer,
} from "react-konva";
import { adjustPolygonPoints } from "../../utils";
import {
  transformPolygonData,
  transformInPolygonData,
} from "../../global/utility/roiUtils";
const columnStyle = {};
const alertAccordionStyle = { width: 200, height: 128 };
const EntryAndExit = ({
  videoSource,
  imageSize,
  eepolygons,
  setEePolygons,
  clearRoi,
  action,
  setIsRoiEdited,
  resetpolygon,
  zone2Color,
  zone1Color,
  lineColor,
  alertAccordion,
  setIsPolygonExceedImageBoundary
}) => {
  const DISPLAY_ACTION = "display";
  const [image, setImage] = useState();
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageRef = useRef(null);
  const dataRef = useRef(null);
  const [points, setPoints] = useState([]);
  const [size, setSize] = useState({});
  const [flattenedPoints, setFlattenedPoints] = useState();
  const [position, setPosition] = useState([0, 0]);
  const [isMouseOverPoint, setMouseOverPoint] = useState(false);
  const [isPolyComplete, setPolyComplete] = useState(false);
  const [polygons, setPolygons] = useState([]);
  const [midpolygons, setMidPolygons] = useState([]);
  const [rotation, setRotation] = useState(0);
  const [prevRotation, setPreRotation] = useState(0);
  const transformerRef = useRef(null);
  const lineRef = useRef(null);
  const [polyPoints, setPolyPoints] = useState([]);
  const [poly_RedPoints, setPoly_RedPoints] = useState([]);
  const [poly_BluePoints, setPoly_BluePoints] = useState([]);
  const [poIndex, setPoIndex] = useState(0);
  const [polyIndex, setPolyIndex] = useState(0);
  const [dirposition, setDirPosition] = useState("");
  const [pIndex, setPindex] = useState(1);
  const [prevAngle, setPrevAngle] = useState(0);
  const [prevPoint, setPrevPoint] = useState();
  const [direction, setDirection] = useState({ dx: 0, dy: 0 });
  const [leftRight, setLeftRight] = useState(""); // "Left" or "Right"
  //const []
  const [endIndex, setEndIndex] = useState("");
  const [dPoints, setDPoints] = useState([150, 100, 100, 200, 200, 200]);
  const [point1, setPoint1] = useState([]);
  const [point2, setPoint2] = useState([]);
  const [downLength, setDownLength] = useState(0);
  const [upLength, setUpLength] = useState(0);
  const extensionLength = action === DISPLAY_ACTION ? 5 : 20;
  const [lineEnd, setLineEnd] = useState({});
  const [lineEnd1, setLineEnd1] = useState({});
  const [lineStart, setLineStart] = useState({});
  //Fixed Height :
  const [fixedHeight, setFixedHeight] = useState(0);

  const distancelength = 25;
  let mode = "";

  // Responsive Stage sizing: cap the Konva Stage to the available viewport width so it
  // does not overflow on tablet and mobile screens. useLayoutEffect (inside useWindowSize)
  // ensures the measurement is synchronous before paint, preventing layout shift.
  const { width: viewportWidth } = useWindowSize();
  const tabletBreak = parseInt(breakpoints.tablet);   // 768
  const desktopBreak = parseInt(breakpoints.desktop); // 1400
  const mobileLgBreak = parseInt(breakpoints.mobileLg); // 480
  const mobileMdBreak = parseInt(breakpoints.mobileMd); // 375
  const contentPad = viewportWidth >= mobileLgBreak ? 40 : viewportWidth >= mobileMdBreak ? 32 : 24;
  const canvasPad = viewportWidth >= mobileMdBreak ? 32 : 24;
  const maxStageWidth = viewportWidth
    ? viewportWidth >= desktopBreak
      ? 832 // large desktop: original full size
      : viewportWidth >= tabletBreak
        ? Math.floor(viewportWidth * 0.62) // tablet/small desktop: 62% of vw
        : viewportWidth - 60 - contentPad - canvasPad // mobile: sidebar(60) + content/canvas padding
    : 832; // SSR / first-render fallback
  // Derive responsive dimensions: if the loaded image is narrower than the cap, use the
  // image's natural dimensions; otherwise scale down proportionally.
  const responsiveWidth = size.width ? Math.min(size.width, maxStageWidth) : maxStageWidth;
  const responsiveHeight = size.width && size.height && size.width > maxStageWidth
    ? Math.round(size.height * (maxStageWidth / size.width))
    : (size.height || Math.round(maxStageWidth * (360 / 480)));

  const videoElement = useMemo(() => {
    const element = new window.Image();
    element.width = imageSize?.width ? imageSize?.width : 832;
    element.height = imageSize?.height ? imageSize?.height : 532;
    element.src = videoSource;
    return element;
  }, [videoSource]); //it may come from redux

  useEffect(() => {
    setImageLoaded(false);
    const onload = function () {
      setSize({
        width: videoElement.width,
        height: videoElement.height,
      });
      setImage(videoElement);
      imageRef.current = videoElement;
      setImageLoaded(true);
    };
    if (action === DISPLAY_ACTION) {
      setImage(videoElement);
      setSize({
        width: videoElement.width,
        height: videoElement.height,
      });
    }

    if (videoElement.complete && videoElement.naturalWidth > 0) {
      onload();
    } else {
      videoElement.addEventListener("load", onload);
    }
    
    return () => {
      videoElement.removeEventListener("load", onload);
    };
  }, [videoElement]);

  const getMousePos = (stage) => {
    return [stage.getPointerPosition().x, stage.getPointerPosition().y];
  };
  //drawing begins when mousedown event fires.
  const handleMouseDown = (e) => {
    if (isPolyComplete) return;
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    if (isMouseOverPoint && points.length >= 3) {
      setPolyComplete(true);
    } else {
      setPoints([...points, mousePos]);
    }
  };
  // Function to get the closest point on a line segment
  const getClosestPointOnLine = (x1, y1, x2, y2, px, py) => {
    const A = px - x1;
    const B = py - y1;
    const C = x2 - x1;
    const D = y2 - y1;

    const dot = A * C + B * D;
    const len_sq = C * C + D * D;
    const param = len_sq !== 0 ? dot / len_sq : -1;

    let xx, yy;
    if (param < 0) {
      xx = x1;
      yy = y1;
    } else if (param > 1) {
      xx = x2;
      yy = y2;
    } else {
      xx = x1 + param * C;
      yy = y1 + param * D;
    }

    return { x: xx, y: yy };
  };
  useEffect(() => {
    if(Object.keys(lineEnd).length > 0 && Object.keys(lineEnd1).length > 0){
    const pointList = [...poly_RedPoints, ...poly_BluePoints,...[lineEnd], ...[lineEnd1] ];
    const isOutOfBounds = pointList.some(
      (point) =>
        point.x < 1 ||
        point.y < 1 ||
        point.x > responsiveWidth - 1 ||
        point.y > responsiveHeight - 1
    );
    setIsPolygonExceedImageBoundary(isOutOfBounds);
  }
  }, [lineEnd, lineEnd1])

  useEffect(() => {
    if (points && points.length) {
      const conterX = points.reduce((sum, p) => sum + p[0], 0) / points.length;
      const conterY = points.reduce((sum, p) => sum + p[1], 0) / points.length;

      //selectiong three points for the split
      const p1 = points[0];
      const ps = points[1];
      const p2 = points[Math.floor(points.length / 2)];
      const p3 = points[points.length - 1];
      const pmid = points[points.length - 2];
      const splitEndX = (pmid[0] + p3[0]) / 2;
      const splitEndY = (pmid[1] + p3[1]) / 2;
      const splitStartX = (p1[0] + ps[0]) / 2;
      const splitStartY = (p1[1] + ps[1]) / 2;

      const midX = (splitStartX + splitEndX) / 2;
      const midY = (splitStartY + splitEndY) / 2;

      const splitPo = points.slice(1, Math.floor(points.length / 2));
      //Creating a midpoints for the split
      const middlePoint = [(p1[0] + p3[0]) / 2, conterY];
      const extendLength = 0; //79.5;
      // const splitPoly = [
      //   ...[midX, midY],
      //   ...points
      //     .slice(1, Math.floor(points.length / 2) + 1)
      //     .concat(position)
      //     .reduce((a, b) => a.concat(b), []),
      //   ...[splitEndX + 15, splitEndY - 50],
      // ];
      const splitPoint = [
        ...points.slice(1, Math.floor(points.length / 2) + 1),
      ];
      const lastarray = splitPoint[splitPoint.length - 1];
      // Example Usage:
      const polygon1 = [lastarray]; // Example polygon 1
      const polygon2 = [[splitEndX, splitEndY]]; // Example polygon 2

      const centerPoint = points[points.length - 2]; //findMidpointBetweenPolygons(polygon1, polygon2);
      // const centerPoint = findThreeQuartersPoint(...polygon1, ...polygon2);
      // const newPoints = [[midX, midY],p1, ...points.slice(1, Math.floor(points.length/2) + 1), [splitEndX+45,splitEndY-15]]; // ...[splitEndX,splitEndY]
      const newPoints = [
        [midX, midY],
        p1,
        ...points.slice(1, Math.floor(points.length / 2) + 1),
        // centerPoint
        //[splitEndX + extendLength, splitEndY],
      ]; // ...[splitEndX,splitEndY]
      const newPointFlat = newPoints.flat();
      setDownLength(newPointFlat.length);
      //const splittedPoints = [midX, midY,...p1, ...points[points.length-1], ...centerPoint ]
      // const newLine = [p1[0], p1[1],midX, midY,splitEndX+45,splitEndY-15];
      const newLine = [p1[0], p1[1], midX, midY, ...centerPoint];

      // Output: [6, 7]
      const polygonPoints = convertArrayToCoordinates(points.flat());
      const polygonPointsRed = convertArrayToCoordinates(newPoints.flat());
      //console.log(polygonPoints, points);
      // const polygonPoints = [
      //   { x: points[0][0], y: points[0][1] },
      //   { x: points[1][0], y: points[1][1] },
      //   { x: points[2][0], y: points[2][1] },
      //   { x: points[3][0], y: points[3][1] },
      // ];
      const endPoint = { x: centerPoint[0], y: centerPoint[1] };
      setPoint1(endPoint);
      setPoint2({ x: p1[0], y: p1[1] });
      setPrevPoint(endPoint);
      setPolyPoints(polygonPoints);
      setPoly_BluePoints(polygonPoints);
      setPoly_RedPoints(polygonPointsRed)
      setLineEnd({
        x: endPoint.x + extensionLength,
        y: endPoint.y + extensionLength,
      });
      setLineEnd1({ x: p1[0] - extensionLength, y: p1[1] - extensionLength });
      const newPolygons = [
        {
          points: points.flat(),
          color: zone2Color,
        },
        {
          points: newPoints.flat(),
          color: zone1Color,
        },
        {
          points: newLine,
          color: lineColor,
        },
      ];
      setPolygons(newPolygons);
      setEePolygons(newPolygons);
    }
  }, [isPolyComplete]);

  useEffect(() => {
    const newPolygons = [...polygons];
    if (newPolygons && newPolygons.length) {
      newPolygons[0].color = zone2Color;
      newPolygons[1].color = zone1Color;
      setPolygons(newPolygons);
    }
  }, [zone2Color, zone1Color]);
  const handleMouseMove = (e) => {
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    setPosition(mousePos);
  };
  const handleMouseOverStartPoint = (e) => {
    if (isPolyComplete || points.length < 3) return;
    e.target.scale({ x: 3, y: 3 });
    setMouseOverPoint(true);
  };
  const handleMouseOutStartPoint = (e) => {
    e.target.scale({ x: 1, y: 1 });
    setMouseOverPoint(false);
  };
  const handlePointDragMove = (e) => {
    const stage = e.target.getStage();
    const index = e.target.index - 1;
    const pos = [e.target._lastPos.x, e.target._lastPos.y];
    if (pos[0] < 0) pos[0] = 0;
    if (pos[1] < 0) pos[1] = 0;
    if (pos[0] > stage.width()) pos[0] = stage.width();
    if (pos[1] > stage.height()) pos[1] = stage.height();
    setPoints([...points.slice(0, index), pos, ...points.slice(index + 1)]);
  };

  useEffect(() => {
    if (resetpolygon && Object.keys(resetpolygon).length > 0) {
      const setoriginalSize = [
        resetpolygon.frame?.maxX
          ? resetpolygon.frame?.maxX
          : resetpolygon.polygon?.frame?.maxX ??
            resetpolygon.polygon?.frame?.maxX,
        resetpolygon.frame?.maxY
          ? resetpolygon.frame?.maxY
          : resetpolygon.polygon?.frame?.maxY ??
            resetpolygon.polygon?.frame?.maxY,
      ];
      const paraentPolygon = transformPolygonData(resetpolygon);
      const ajPolygonPoints = adjustPolygonPoints(
        setoriginalSize,
        paraentPolygon,
        [imageSize?.width, imageSize?.height]
      );
      const inPolygon = transformInPolygonData(
        resetpolygon?.direction?.in_polygon?.edges
      );
      const ajInPolygon = adjustPolygonPoints(setoriginalSize, inPolygon, [
        imageSize?.width,
        imageSize?.height,
      ]);
      const splitPolygon = transformInPolygonData(
        resetpolygon?.direction?.splitter
      );
      const ajSplitPolygon = adjustPolygonPoints(
        setoriginalSize,
        splitPolygon,
        [imageSize?.width, imageSize?.height]
      );
      const polygonPoints = convertArrayToCoordinates(ajPolygonPoints.flat());
      const polygonPointsRed = convertArrayToCoordinates(ajInPolygon.flat());
      const endPoint = {
        x: ajInPolygon[ajInPolygon.length - 1][0],
        y: ajInPolygon[ajInPolygon.length - 1][1],
      };
      const newLine = [
        ajSplitPolygon[0][0],
        ajSplitPolygon[0][1],
        ajInPolygon[0][0],
        ajInPolygon[0][1],
        ajInPolygon[ajInPolygon.length - 1][0],
        ajInPolygon[ajInPolygon.length - 1][1],
      ];
      setPoint1(endPoint);
      setPoint2({ x: ajSplitPolygon[0][0], y: ajSplitPolygon[0][1] });
      setPrevPoint(endPoint);
      setPolyPoints(polygonPoints);
      setPoly_BluePoints(polygonPoints);
      setPoly_RedPoints(polygonPointsRed)
      setLineEnd({
        x: endPoint.x + extensionLength,
        y: endPoint.y + extensionLength,
      });
      setLineEnd1({
        x: ajSplitPolygon[0][0] - extensionLength,
        y: ajSplitPolygon[0][1] - extensionLength,
      });
      const newPointFlat = ajInPolygon.flat();
      setDownLength(newPointFlat.length);
      //console.log(ajPolygonPoints, inPolygon, splitPolygon, "");
      const newPolygons = [
        {
          points: ajPolygonPoints.flat(),
          color: zone2Color,
        },
        {
          points: ajInPolygon.flat(),
          color: zone1Color,
        },
        {
          points: newLine,
          color: lineColor,
        },
      ];
      setPolygons(newPolygons);
      if (action !== DISPLAY_ACTION) {
        setEePolygons(newPolygons);
      }
    }
  }, [resetpolygon]);

  useEffect(() => {
    if (clearRoi && action !== DISPLAY_ACTION) {
      setPoints([]);
      setPolygons([]);
      setEePolygons([]);
      setPoint1({});
      setPoint2({});
      setPrevPoint({});
      setPolyPoints([]);
      setPoly_BluePoints([]);
      setPoly_RedPoints([])
      setLineEnd({});
      setLineEnd1({});
      setPolyComplete(false);
      setDownLength(0);
      setUpLength(0);
    }
  }, [clearRoi]);

  useEffect(() => {
    setFlattenedPoints(
      points
        .concat(isPolyComplete ? [] : position)
        .reduce((a, b) => a.concat(b), [])
    );
  }, [points]);
  const undo = () => {
    setPoints(points.slice(0, -1));
    setPolyComplete(false);
  };
  const handleGroupDragEnd = (e) => {
    //drag end listens other children circles' drag end event
    //...that's, why 'name' attr is added, see in polygon annotation part
    if (e.target.name() === "polygon") {
      let result = [];
      let copyPoints = [...points];
      copyPoints.map((point) =>
        result.push([point[0] + e.target.x(), point[1] + e.target.y()])
      );
      e.target.position({ x: 0, y: 0 }); //needs for mouse position otherwise when click undo you will see that mouse click position is not normal:)
      setPoints(result);
    }
  };
  function calculateCentroid(polygon) {
    let xSum = 0,
      ySum = 0,
      n = polygon.length;

    polygon.forEach((point) => {
      xSum += point[0]; // Sum of x-coordinates
      ySum += point[1]; // Sum of y-coordinates
    });

    return [xSum / n, ySum / n]; // Centroid (Cx, Cy)
  }
  function findThreeQuartersPoint(x1, y1, x2, y2) {
    let x3q = x1 + (3 / 4) * (x2 - x1);
    let y3q = y1 + (3 / 4) * (y2 - y1);
    return [x3q, y3q];
  }

  function findMidpointBetweenPolygons(polygon1, polygon2) {
    const centroid1 = calculateCentroid(polygon1);
    const centroid2 = calculateCentroid(polygon2);

    // Midpoint formula
    const midX = (centroid1[0] + centroid2[0]) / 2;
    const midY = (centroid1[1] + centroid2[1]) / 2;

    return [midX, midY]; // Midpoint between the two centroids
  }

  const isPointOnPolygonBorder = (polygon, px, py, tolerance = 1.5) => {
    for (let i = 0; i < polygon.length; i++) {
      const p1 = polygon[i];
      const p2 = polygon[(i + 1) % polygon.length];

      const closest = getClosestPointOnLine(p1.x, p1.y, p2.x, p2.y, px, py);
      const dist = Math.hypot(px - closest.x, py - closest.y);

      if (dist <= tolerance) {
        return true; // The point is very close to the edge (on border)
      }
    }
    return false;
  };
  function convertArrayToCoordinates(arr) {
    if (arr.length % 2 !== 0) {
      throw new Error("Invalid input: Array length must be even");
    }

    let coordinates = [];
    for (let i = 0; i < arr.length; i += 2) {
      coordinates.push({ x: arr[i], y: arr[i + 1] });
    }

    return coordinates;
  }
  function convertArrayToCoordinatesAj(arr, x, y) {
    if (arr.length % 2 !== 0) {
      throw new Error("Invalid input: Array length must be even");
    }

    let coordinates = [];
    for (let i = 0; i < arr.length; i += 2) {
      coordinates.push(...[arr[i] + x, arr[i + 1] + y]);
    }

    return coordinates;
  }
  const calculateDistance = () => {
    return Math.sqrt(
      Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2)
    );
  };
  const findBounds = (points) => {
    const xValues = points.filter((_, index) => index % 2 === 0);
    const yValues = points.filter((_, index) => index % 2 !== 0);
    //console.log(xValues, yValues, "points >>>");

    return {
      minX: Math.min(...xValues),
      minY: Math.min(...yValues),
      maxX: Math.max(...xValues),
      maxY: Math.max(...yValues),
    };
  };
  const isTouchingEdge = (points, poly) => {
    const { minX, minY, maxX, maxY } = findBounds(poly);
    return points.some((value, index) => {
      if (index % 2 === 0) {
        return value <= minX || value >= maxX;
      } else {
        return value <= minY || value >= maxY;
      }
    });
  };
  const handleDragEnd = (e, index) => {
    if (calculateDistance() < distancelength) {
      return;
    }
    const newPolygons = [...polygons];
    const splitPoly = newPolygons[1].points;
    const clone = JSON.parse(JSON.stringify(newPolygons[1].points));
    const convertArr = convertArrayToCoordinates(clone);
    const checkPolygon1 = isPointOnPolygonBorder(
      convertArr,
      point1.x,
      point1.y
    );
    mode = "";
    const returnPolygon = getCornerPointsBetween(convertArrayToCoordinates(newPolygons[0].points), point2, point1);
    //console.log(convertArrayToCoordinates(newPolygons[0].points), point2, point1, returnPolygon, ">>>")
    const start = [point2].flatMap(p=>[p.x,p.y]);
    const end = [point1].flatMap(p=>[p.x,p.y]);
    const middleArr = returnPolygon.flatMap(p=>[p.x,p.y]);
    //console.log("result :", [clone[0],clone[1], ...start, ...middleArr, ...end]);
   newPolygons[1].points = [clone[0],clone[1], ...start, ...middleArr, ...end];
    // const exist = addUniquePoints(returnPolygon, point1.x, point1.y);

    setPolygons(newPolygons);
    setEePolygons(newPolygons);
    setIsRoiEdited(action === "update" ? true : false);
  };
  const checkDistance = () => {
    let checkStatus = true;
    if (calculateDistance() < distancelength) {
      checkStatus = false;
    }
    return checkStatus;
  };
  
 
    
  const handleGroupDrag = (e) => {
    if (e.target.name() === "grouppolygon") {
      const newPolygons = [...polygons];
      newPolygons[0].points = convertArrayToCoordinatesAj(
        newPolygons[0].points,
        e.target.x(),
        e.target.y()
      );
      newPolygons[1].points = convertArrayToCoordinatesAj(
        newPolygons[1].points,
        e.target.x(),
        e.target.y()
      );
      newPolygons[2].points = convertArrayToCoordinatesAj(
        newPolygons[2].points,
        e.target.x(),
        e.target.y()
      );
      setPolygons(newPolygons);
      setPoint1({ x: point1.x + e.target.x(), y: point1.y + e.target.y() });
      setPoint2({ x: point2.x + e.target.x(), y: point2.y + e.target.y() });
      setLineEnd({ x: lineEnd.x + e.target.x(), y: lineEnd.y + e.target.y() });
      setLineEnd1({
        x: lineEnd1.x + e.target.x(),
        y: lineEnd1.y + e.target.y(),
      });
      setEePolygons(newPolygons);
      setPrevPoint({ x: point1.x + e.target.x(), y: point1.y + e.target.y() });
      setPolyPoints(convertArrayToCoordinates(newPolygons[0].points));
      setPoly_BluePoints(convertArrayToCoordinates(newPolygons[0].points));
      setPoly_RedPoints(convertArrayToCoordinates(newPolygons[1].points));
      e.target.position({ x: 0, y: 0 });
      setIsRoiEdited(action === "update" ? true : false);
    }
  };
  
function pointEquals(p1, p2) {
  return Math.abs(p1.x - p2.x) < 1e-6 && Math.abs(p1.y - p2.y) < 1e-6;
}

function pointOnEdge(p1, p2, point, epsilon = 1e-2) {
  const cross = (point.y - p1.y) * (p2.x - p1.x) - (point.x - p1.x) * (p2.y - p1.y);
  if (Math.abs(cross) > epsilon) return false;

  const dot = (point.x - p1.x) * (p2.x - p1.x) + (point.y - p1.y) * (p2.y - p1.y);
  if (dot < -epsilon) return false;

  const lenSq = Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2);
  return dot <= lenSq + epsilon;
}

function findEdgeIndex(polygon, point) {
  for (let i = 0; i < polygon.length; i++) {
    const a = polygon[i];
    const b = polygon[(i + 1) % polygon.length];
    if (pointOnEdge(a, b, point)) return i;
  }
  return -1;
}

function getCornerPointsBetween(polygon, startPoint, endPoint) {
  const total = polygon.length;
  const startEdgeIndex = findEdgeIndex(polygon, startPoint);
  const endEdgeIndex = findEdgeIndex(polygon, endPoint);

  if (startEdgeIndex === -1 || endEdgeIndex === -1) {
    console.warn("Start or end point is not on polygon edges.");
    return [];
  }

  const corners = [];
  let i = (startEdgeIndex + 1) % total;

  while (true) {
    const point = polygon[i];

    // Stop AFTER adding the last corner (endEdge's start corner)
    if (i === (endEdgeIndex + 1) % total) break;

    corners.push(point);
    i = (i + 1) % total;
  }

  return corners;
}

  return (
    <div className="polygon-ee-stage-wrapper">
    <div style={Boolean(alertAccordion) ? alertAccordionStyle : columnStyle}>
      <Stage
        width={responsiveWidth}
        height={responsiveHeight}
        onMouseMove={handleMouseMove}
        onMouseDown={handleMouseDown}
      >
        <Layer>
          <Image
            ref={imageRef}
            image={image}
            x={0}
            y={0}
            width={responsiveWidth}
            height={responsiveHeight}
          />
          {imageLoaded && polygons.length === 0 && (
            <PolygonAnnotation
              points={points}
              flattenedPoints={flattenedPoints}
              handlePointDragMove={handlePointDragMove}
              handleGroupDragEnd={handleGroupDragEnd}
              handleMouseOverStartPoint={handleMouseOverStartPoint}
              handleMouseOutStartPoint={handleMouseOutStartPoint}
              isFinished={isPolyComplete}
            />
          )}
          {imageLoaded && polygons.length > 0 && <Group
            name="grouppolygon"
            x={0}
            y={0}
            draggable={action !== DISPLAY_ACTION ? true : false}
            onDragEnd={(e) => {
             // console.log("Group Position:", e.target.x(), e.target.y());
              handleGroupDrag(e);
            }}
          >
            {polygons &&
              polygons.map((poly, index) => (
                <React.Fragment key={index}>
                  <Line
                    key={index}
                    points={poly.points}
                    closed={index === 2 ? false : true}
                    fill={index === 2 ? "" : poly.color}
                    stroke={index === 2 ? "White" : ""}
                    //stroke="black"
                    // rotation={rotation}
                    // onTransformStart={handleTransstartEnd}
                    // onTransformEnd={handleTransformEnd}
                    ref={lineRef}
                    strokeWidth={2}
                  />

                  {index === 2 &&
                    poly.points.map((_, pointIndex) =>
                      //  (pointIndex % 2 === 0 && poly.color !== "red" && pointIndex <= 2) || (pointIndex % 2 === 0 && poly.color !== "red" && poly.points.length-2===pointIndex)? (

                      pointIndex % 2 === 0 ? (
                        <React.Fragment key={pointIndex}>
                          {pointIndex === 2 && (
                            <Circle
                              key={pointIndex}
                              x={poly.points[pointIndex]}
                              y={poly.points[pointIndex + 1]}
                              radius={action !== DISPLAY_ACTION ? 5 : 2}
                              fill="#FFE97A"
                              // draggable={pointIndex !== 2 ? true : false}
                              strokeWidth={2}
                              dash={[5, 5]}
                              // onDragMove={(e)=> {handleDrag(index, pointIndex !== 2 ? pointIndex / 2 :  null, e)}}
                            />
                          )}
                          {/* //onDragMove={(e)=> {handleDrag(index, pointIndex/2, e)}} /> */}
                        </React.Fragment>
                      ) : null
                    )}
                  {point1 && (
                    <>
                      <Line
                        points={[point1.x, point1.y, lineEnd.x, lineEnd.y]}
                        stroke="white"
                        strokeWidth={2}
                      />
                      <Circle x={point1.x} y={point1.y} radius={1} fill="red" />
                      <Rect
                        x={lineEnd.x}
                        y={lineEnd.y}
                        width={action !== DISPLAY_ACTION ? 10 : 2}
                        height={action !== DISPLAY_ACTION ? 10 : 2}
                        // radius={5}
                        fill="yellow"
                        draggable={action !== DISPLAY_ACTION ? true : false}
                        onDragEnd={(e) => {
                          handleDragEnd(e, 2);
                        }}
                        onDragMove={(e) => {
                          let closest = null;
                          let minDist = Infinity;

                          const newPoint = { x: e.target.x(), y: e.target.y() };
                          // setPoint(newPoint);

                          // Calculate direction (dx, dy)
                          const dx = newPoint.x - prevPoint.x;
                          const dy = newPoint.y - prevPoint.y;
                          setDirection({ dx, dy });

                          // Find the closest edge the point is currently on
                          let closestEdge = null;
                          for (let i = 0; i < polyPoints.length; i++) {
                            const p1 = polyPoints[i];
                            const p2 = polyPoints[(i + 1) % polyPoints.length];

                            const closestPoint = getClosestPointOnLine(
                              p1.x,
                              p1.y,
                              p2.x,
                              p2.y,
                              newPoint.x,
                              newPoint.y
                            );
                            // if (closestPoint.x === newPoint.x && closestPoint.y === newPoint.y) {
                            //   closestEdge = { start: p1, end: p2 };
                            //   break;
                            // }
                            const dist = Math.hypot(
                              newPoint.x - closestPoint.x,
                              newPoint.y - closestPoint.y
                            );

                            if (dist < minDist) {
                              minDist = dist;
                              closest = closestPoint;
                            }
                          }
                          setPoint1(closest);
                          setLineEnd(newPoint);
                          const newPolygons = [...polygons];
                          //const splitPoly = newPolygons[1].points;
                          newPolygons[2].points[2 * 2] = closest.x;
                          newPolygons[2].points[2 * 2 + 1] = closest.y;
                          // if (
                          //   isTouchingEdge(
                          //     [closest.x, closest.y],
                          //     newPolygons[0].points
                          //   )
                          // ) {
                          //   // console.log("isTouchingEdge >>>", downLength);
                          //   // splitPoly.splice(downLength-1 + 1, 0, ...[closest.x, closest.y]);
                          //   splitPoly[downLength - 1 + 1] = closest.x;
                          //   splitPoly[downLength - 1 + 2] = closest.y;
                          //   setDownLength(downLength + 2);
                          // }
                        // const poly = convertArrayToCoordinates(newPolygons[0].points)
                        //  if (isTouchingEdge([newPoint.x, newPoint.y], newPolygons[0].points)) {
                        //     console.log("isTouchingEdge >>>", newPoint.x, newPoint.y);
                        //  }
                      //  console.log(newPolygons[0].points, "Points >>>");
                       // isPointInPolygon(newPolygons[0].points, newPoint.x, newPoint.y);
                          setPolygons(newPolygons);
                          setEePolygons(newPolygons);

                          // Update previous position for next move
                          setPrevPoint(newPoint);
                        }}
                      />
                    </>
                  )}
                  {point2 && (
                    <>
                      <Line
                        points={[point2.x, point2.y, lineEnd1.x, lineEnd1.y]}
                        stroke="white"
                        strokeWidth={2}
                      />
                      <Circle x={point2.x} y={point2.y} radius={1} fill="red" />
                      <Rect
                        x={lineEnd1.x}
                        y={lineEnd1.y}
                        //radius={5}
                        fill="yellow"
                        width={action !== DISPLAY_ACTION ? 10 : 2}
                        height={action !== DISPLAY_ACTION ? 10 : 2}
                        draggable={action !== DISPLAY_ACTION ? true : false}
                        onDragEnd={(e) => {
                          handleDragEnd(e, 0);
                        }}
                        onDragMove={(e) => {
                          let closest = null;
                          let minDist = Infinity;

                          const newPoint = { x: e.target.x(), y: e.target.y() };
                          // setPoint(newPoint);

                          // Calculate direction (dx, dy)
                          // const dx = newPoint.x - prevPoint.x;
                          // const dy = newPoint.y - prevPoint.y;
                          // setDirection({ dx, dy });

                          // Find the closest edge the point is currently on
                          let closestEdge = null;
                          for (let i = 0; i < polyPoints.length; i++) {
                            const p1 = polyPoints[i];
                            const p2 = polyPoints[(i + 1) % polyPoints.length];

                            const closestPoint = getClosestPointOnLine(
                              p1.x,
                              p1.y,
                              p2.x,
                              p2.y,
                              newPoint.x,
                              newPoint.y
                            );
                            // if (closestPoint.x === newPoint.x && closestPoint.y === newPoint.y) {
                            //   closestEdge = { start: p1, end: p2 };
                            //   break;
                            // }
                            const dist = Math.hypot(
                              newPoint.x - closestPoint.x,
                              newPoint.y - closestPoint.y
                            );

                            if (dist < minDist) {
                              minDist = dist;
                              closest = closestPoint;
                            }
                          }
                          setPoint2(closest);
                          setLineEnd1(newPoint);

                          const newPolygons = [...polygons];
                          //const splitPoly = newPolygons[1].points;
                          newPolygons[2].points[0 * 2] = closest.x;
                          newPolygons[2].points[0 * 2 + 1] = closest.y;
                         
                          // if(isTouchingEdge([closest.x,closest.y], newPolygons[0].points)) {
                          //   const pointIndex = isPointInPolygon(newPolygons[1].points, closest.x,closest.y);
                          //   console.log("Yes I am Touching", pointIndex, closest.x,closest.y)
                          //     if(pointIndex !==-1) {
                          //       newPolygons[1].points.splice(pointIndex, 2);
                          //      // setPindex(pointIndex);
                          //      console.log("Remove from EE", newPolygons[1].points, pointIndex);
                          //     } else {
                          //       newPolygons[1].points.splice(2, 0, ...[closest.x, closest.y]);
                          //      // setPindex(pIndex+1)
                          //       console.log("Add from EE", pIndex);

                          //     }
                          // }
                          setPolygons(newPolygons);
                          setEePolygons(newPolygons);
                        }}
                      />
                    </>
                  )}
                </React.Fragment>
              ))}
          </Group>}
        </Layer>
      </Stage>
      </div>
    </div>
  );
};

export default EntryAndExit;
